import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { selectInitialHashedPin } from 'store/shipping/shippingSelectors'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { colors, breakpoints } from 'globalStyles'
import { setIsGuestMode } from 'store/shipping/shippingSlice'

const StyledButton = styled.button`
  width: 600px;
  @media ${breakpoints.phone} {
    max-width: 328px;
  }
  margin-top: 24px;
  height: 50px;
  background-color: ${colors.primary_white};
  color: ${colors.primary_blue};
  border: 1px solid ${colors.primary_blue};
  border-radius: 4px;
  &:hover {
    color: ${colors.text_link_hover};
    border-color: ${colors.text_link_hover};
  }
`

const GuestButton = ({ isSrcLandingPage }) => {
  const dispatch = useDispatch()
  const hashPin = useSelector(selectInitialHashedPin)
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const { language: lang } = i18n

  if (typeof hashPin === 'undefined' || !hashPin) {
    return null
  }

  const onClickContinueAsGuest = () => {
    if (hashPin) {
      dispatch(setIsGuestMode(true))
      navigate(`/rs/tr/${lang}/${hashPin}`)
    }
  }

  if (!hashPin) {
    navigate(`/rs/tr/${lang}/*`)
  }

  return !isSrcLandingPage ? (
    <Button variant="link" onClick={onClickContinueAsGuest}>
      {t('login.continue_as_guest')}
    </Button>
  ) : (
    <StyledButton onClick={onClickContinueAsGuest}>
      {t('landing_page.skip_registration')}
    </StyledButton>
  )
}

GuestButton.propTypes = {
  isSrcLandingPage: PropTypes.bool,
}

GuestButton.defaultProps = {
  isSrcLandingPage: false,
}

export default GuestButton
